export const ImageLightbox = ({ image, onClose }) => {
  if (!image) return null;

  return (
    <div
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="image-lightbox"
    >
      <div className="relative max-w-5xl w-full">
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 text-white hover:text-blue-300 text-4xl font-light transition-colors"
          aria-label="Close"
          data-testid="lightbox-close-btn"
        >
          ×
        </button>
        <img
          src={image.url}
          alt={image.caption}
          className="w-full h-auto rounded-lg shadow-2xl"
        />
        <p className="text-white text-center mt-6 font-sans text-lg">{image.caption}</p>
      </div>
    </div>
  );
};
